export default function imageLoaded() {
  return function link($scope, $element, $attrs) {
    $element.on('load', () => {
      $scope.$evalAsync(() => {
        $scope.$eval($attrs.imageLoaded);
      });
    });
    $element.on('error', () => {
      $scope.$evalAsync(() => {
        $scope.$eval($attrs.imageLoadedError);
      });
    });
  };
}
